import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const AboutUsSection = () => {
  const aboutDetails = [
    {
      title: "💡 Instant expert assistance",
      description:
        "Need help booking an affordable flight or have travel-related queries? Our friendly support team is available 24/7 to guide you with expert advice.",
    },
    {
      title: "✈️ Personalized flight options",
      description:
        "Our dedicated Travel Coordinators will present you with the best flight options within minutes, ensuring a seamless and tailored booking experience.",
    },
    {
      title: "📩 Hassle-Free Travel Booking",
      description:
        "Securely book your flight and receive e-tickets instantly via email. Our customer support team is always ready to assist you with any concerns.",
    },
  ];

  return (
    <Container className="py-5">
      <h2 className="text-center fw-bold mb-4">Who We Are?</h2>
      <Row className="justify-content-center">
        {aboutDetails.map((item, index) => (
          <Col md={4} key={index} className="mb-3">
            <Card className="shadow-sm border-0 rounded-3 text-center p-3">
              <Card.Body>
                <Card.Title className="fw-bold">{item.title}</Card.Title>
                <Card.Text className="text-muted">{item.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default AboutUsSection;
